import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { contactInfo } from '../../data/contact-info';

const ContactInfo = () => {
  return (
    <div className="bg-white p-6 rounded-lg border-2 border-primary/30 shadow-lg h-[350px] flex items-center overflow-auto">
      <div className="space-y-4 w-full">
        <div className="flex gap-4 items-center">
          <div className="bg-primary/10 p-3 rounded-full flex-shrink-0 transition-all duration-300 hover:scale-125">
            <a href={`tel:${contactInfo.phone.display.split('|')[0].trim().replace(/\s+/g, '')}`}>
              <Phone size={24} className="text-[#0EA5E9] transition-all duration-300" />
            </a>
          </div>
          <div>
            <p className="font-medium">Telefon</p>
            <p className="text-muted-foreground">{contactInfo.phone.display}</p>
          </div>
        </div>
        
        <div className="flex gap-4 items-center">
          <div className="bg-primary/10 p-3 rounded-full flex-shrink-0 transition-all duration-300 hover:scale-125">
            <a href={`mailto:${contactInfo.email}`}>
              <Mail size={24} className="text-[#0EA5E9] transition-all duration-300" />
            </a>
          </div>
          <div>
            <p className="font-medium">E-Mail</p>
            <p className="text-muted-foreground">{contactInfo.email}</p>
          </div>
        </div>
        
        <div className="flex gap-4 items-center">
          <div className="bg-primary/10 p-3 rounded-full flex-shrink-0 transition-all duration-300 hover:scale-125">
            <MapPin size={24} className="text-[#0EA5E9] transition-all duration-300" />
          </div>
          <div>
            <p className="font-medium">Adresse</p>
            <p className="text-muted-foreground">Hebelstraße 2, 78564 Wehingen</p>
          </div>
        </div>
        
        <div className="flex gap-4 items-center">
          <div className="bg-primary/10 p-3 rounded-full flex-shrink-0 transition-all duration-300 hover:scale-125">
            <Clock size={24} className="text-[#0EA5E9] transition-all duration-300" />
          </div>
          <div>
            <p className="font-medium">Geschäftszeiten</p>
            <p className="text-muted-foreground">Montag - Freitag: {contactInfo.hours.weekdays}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
